import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { TridentAuthProvider } from "@/contexts/TridentAuthContext";
import { TridentCartProvider } from "@/contexts/TridentCartContext";
import TridentAuthGate from "./TridentAuthGate";
import TridentCartButton from "./TridentCartButton";

/**
 * Shared provider layout for all authenticated Trident member pages.
 * Wrapping the routes in a single layout keeps the Auth + Cart providers
 * mounted while the user navigates between Trident Product Catalog and
 * T3 University, so cart items and the auth session persist.
 */
// Member pages are never prerendered, so the tab title is set here (the
// static shell carries the generic site title). Applies to the sign-in
// gate too, which renders before any page inside the area.
const TRIDENT_TITLES: Record<string, string> = {
  "/hardscaping/trident/": "Trident Product Catalog | Trident Member Portal",
  "/hardscaping/trident/university/": "T3 University | Trident Member Portal",
};

export default function TridentAreaLayout() {
  const { pathname } = useLocation();
  const title = TRIDENT_TITLES[pathname.endsWith("/") ? pathname : `${pathname}/`] || "Trident Member Portal | Enzo's Cleaning Solutions";
  return (
    <TridentAuthProvider>
      <Helmet>
        <title>{title}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <TridentAuthGate>
        <TridentCartProvider>
          <Outlet />
          <TridentCartButton />
        </TridentCartProvider>
      </TridentAuthGate>
    </TridentAuthProvider>
  );
}
